export type TierId = 'free' | 'member' | 'scholar';

export interface PricingTier {
  id: TierId;
  name: string;
  tagline: string;
  price: number;
  period: string;
  features: string[];
  cta: 'current' | 'subscribe';
}

export interface PricingConfig {
  currency: 'GBP' | 'EUR' | 'USD';
  symbol: string;
  country: string | null;
  tiers: PricingTier[];
}

class PricingService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_BASE_URL || '';
  }

  // Prices are localised server-side from the caller's country,
  // so the currency decision lives entirely behind this endpoint.
  async fetchPricing(): Promise<PricingConfig> {
    const response = await fetch(`${this.baseUrl}/api/pricing`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to load pricing');
    }

    return response.json();
  }
}

export const pricingService = new PricingService();
